declare global {
  interface Window {
    __ENV_CONFIG__: EnvVariables;
  }
}

export interface EnvVariables {
  environment: 'devint' | 'qa' | 'prod';
  amazonDemandPartnerId: string;
  aquaDemandPartnerId: string;
  apiRequestLimit: number;
  apiRequestLimitAccount: number;
  apiRequestLimitUserList: number;
  australiaAccountId: string;
  bqJobMaxRequestCount: number;
  bqJobRefetchInterval: number;
  corporateInstanceUid: string;
  dv360DemandPartnerId: string;
  tablePageSize: number;
  ttdDemandPartnerId: string;
  xandrDemandPartnerId: string;
  openAudienceOrgId: string;
  openAudienceOrgUid: string;
  openAudienceOrgExternalId: string;
  source?: string;
  ssoAuthority?: string;
  ssoClientId?: string;
  ssoEmailSecurityKey: string;
  ssoRedirectUri?: string;
  ssoIdentityProviderKey?: string;
  pendoApiKey?: string;
  minimumDateForTTDSync?: string;
  amazonDealSyncStartDate?: string;
  minimumEstimatedReach: number;
  growthbookApiKey: string;
  growthbookApiHost: string;
  creativeSandboxUrl: string;
  unityOrigin: string;
  isLocalEnv: boolean;
}

export const defaultUiParameters: EnvVariables = {
  environment: 'devint',
  amazonDemandPartnerId: '537073219',
  aquaDemandPartnerId: '558769495',
  apiRequestLimit: 50,
  apiRequestLimitAccount: 9999,
  apiRequestLimitUserList: 200,
  australiaAccountId: 'e28733bf-7811-4d67-915d-9becf36e44a6',
  openAudienceOrgId: '542346655',
  openAudienceOrgUid: '6026b533-accf-fff1-8123-f79a25',
  openAudienceOrgExternalId: '104bb65d-887d-4249-98e6-b8522e209fae',
  bqJobMaxRequestCount: 300,
  bqJobRefetchInterval: 1000,
  corporateInstanceUid: 'bbca0a92-7a68-469b-a03f-40f09ba54639',
  dv360DemandPartnerId: '537073246',
  minimumDateForTTDSync: '2025-12-31 21:37:00',
  amazonDealSyncStartDate: '2026-09-22 06:00:00',
  source: 'fallback',
  ssoEmailSecurityKey: 'HOkULc7fa5DhOcJ0',
  ssoIdentityProviderKey: 'AIzaSyCLvqp5phL0yGo0uxIN-l7a58mPkV74hsw', // public key from our docs
  tablePageSize: 50,
  ttdDemandPartnerId: '537073292',
  xandrDemandPartnerId: '537072400',
  minimumEstimatedReach: 30000,
  growthbookApiKey: 'sdk-UzQKNNNzDSUG53H',
  growthbookApiHost: 'https://growthbook-api.openx.com',
  creativeSandboxUrl: 'https://openxadpreview.com/shim.html',
  unityOrigin: 'https://ui.devint.gcp.openx.org',
  isLocalEnv: true,
};

export function getEnvVariables(): EnvVariables {
  const envVariables = window.__ENV_CONFIG__ ?? {};

  const envVars = { ...defaultUiParameters, ...envVariables, isLocalEnv: process.env.NODE_ENV === 'development' };

  const numVal = [
    'apiRequestLimit',
    'apiRequestLimitAccount',
    'apiRequestLimitUserList',
    'bqJobMaxRequestCount',
    'bqJobRefetchInterval',
    'tablePageSize',
    'minimumEstimatedReach',
  ];
  numVal.forEach(key => {
    if (envVars[key] && typeof envVars[key] === 'string') {
      envVars[key] = parseInt(envVars[key], 10);
    }
  });

  return envVars;
}
